import { Component, OnInit } from '@angular/core';
import {MdDialogRef, MdSnackBar} from '@angular/material';
import * as moment from 'moment';
import {ColaboradoresService} from '../../../../services';

const key = 'agrisJDEInfo';

@Component({
  selector: 'app-agris-acceso-restringido-dialog',
  templateUrl: './agris-acceso-restringido-dialog.component.html',
  styleUrls: ['./agris-acceso-restringido-dialog.component.scss', '../agris-common-styles.scss']
})
export class AgrisAccesoRestringidoDialogComponent {

  puedeSolicitar = false;

  constructor(
    public dialogRef: MdDialogRef<AgrisAccesoRestringidoDialogComponent>,
    private colaboradoresService: ColaboradoresService,
    private snackbar: MdSnackBar
  ) {
    const rawData = localStorage.getItem(key);
    if (rawData !== null && rawData !== '[]') {
      // obtenemos las solicitudes realizadas en este browser
      let data = JSON.parse(rawData) as AgrisJDEInfo[];
      const userId = localStorage.getItem('userId');

      // verificamos si el user ya realizó una solicitud en las ultimas 48hs
      const itemFound = data.find(x => userId == x.userId);
      if (itemFound !== null && itemFound !== undefined) {
        // se encontro un item, verificamos que haya pasado al menos 48hs
        if (moment().diff(moment.unix(itemFound.date), 'days') >= 2) {
          // si pasaron mas de 48hs, quitamos el valor del objeto y permitimos una nueva solicitud
          data = data.filter(x => x.userId !== userId);
          this.puedeSolicitar = true;
          // actualizamos el objeto con el ultimo cambio
          localStorage.setItem(key, JSON.stringify(data));
        }
      } else {
        // no se encontro una solicitud reciente por lo que podemos solicitar una
        this.puedeSolicitar = true;
      }

    } else {
      this.puedeSolicitar = true;
      // no hay objeto en el localstorage, lo generamos
      localStorage.setItem(key, '[]');
    }
  }

  solicitarUsuario() {
    this.colaboradoresService.getUserJDEAccess().subscribe(x => {
      if (x) {
        // luego de solicitar, creamos el objeto para insertar
        const data = JSON.parse(localStorage.getItem(key)) as AgrisJDEInfo[];
        const obj: AgrisJDEInfo = {
          userId: localStorage.getItem('userId'),
          date: moment().unix()
        }
        data.push(obj);
        localStorage.setItem(key, JSON.stringify(data));
        this.snackbar.open(
          'Se solicitó el alta de usuario, dentro de las próximas 24/48 hs recibirá el aviso de solución del caso',
          null,
          {duration: 5000}
        );
        this.dialogRef.close();
      }
    });
  }

}

interface AgrisJDEInfo {
  userId: string,
  date: number,
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-acceso-restringido-dialog/agris-acceso-restringido-dialog.component.ts